import React, { useState, useEffect } from 'react';
import { X, Hand } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

interface SwipeEducationModalProps {
  onClose: () => void;
}

const SwipeEducationModal: React.FC<SwipeEducationModalProps> = ({ onClose }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    const hasSeenSwipeEducation = localStorage.getItem('hasSeenSwipeEducation');
    if (!hasSeenSwipeEducation && isMobile) {
      setIsOpen(true);
    }
  }, [isMobile]);

  const handleClose = () => {
    localStorage.setItem('hasSeenSwipeEducation', 'true');
    setIsOpen(false);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[70] p-4">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.95 }}
          className="bg-theme-cards rounded-2xl shadow-card border border-theme-cards max-w-md w-full p-6"
        >
          <div className="flex flex-col items-center text-center">
            <div className="w-16 h-16 rounded-full bg-gradient-to-br from-pink-500 to-cyan-500 flex items-center justify-center mb-4">
              <Hand className="w-8 h-8 text-white" />
            </div>

            <h2 className="text-xl font-bold text-contrast mb-3">
              Hide Vybes you're not into
            </h2>

            <p className="text-theme-text-secondary text-sm leading-relaxed mb-6">
              You can swipe away Vybes you're not interested in. They'll disappear for now — but don't worry, you'll always discover new ones.
            </p>

            <button
              onClick={handleClose}
              className="w-full bg-gradient-to-r from-pink-500 to-cyan-500 hover:from-pink-600 hover:to-cyan-600 text-white px-6 py-3 rounded-full transition-all font-semibold shadow-lg"
            >
              Got it
            </button>
          </div>
        </motion.div>
      </div>
    </AnimatePresence>
  );
};

export default SwipeEducationModal;
